import { authDataIdentity, subscribeAuthDataIdentity } from "@rekonas/data-access";
import { useSyncExternalStore } from "react";
import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { fetchPositionDistributionPath, authCacheScope, fetchDemoCapabilities, fetchDemoOverview, fetchDemoWindow,
  getDemoRecording, operationalKeys } from "@rekonas/data-access";
import { SignalViewer, profileWithOrientationModels, type ViewerDataSource } from "@rekonas/signal-viewer";
import { Alert, Spinner } from "@rekonas/ui";

export function DemoRecordingPage() {
  const accessIdentity=useSyncExternalStore(subscribeAuthDataIdentity,authDataIdentity,authDataIdentity);
  const query = useQuery({ queryKey: operationalKeys.demo(),
    queryFn: ({ signal }) => getDemoRecording(signal), retry: false });
  const recording = query.data;
  const source = useMemo<ViewerDataSource | null>(() => recording ? ({
    key: [...operationalKeys.demoSignals(recording.recording_ref, recording.data_version), accessIdentity],
    recordingRef: recording.recording_ref,
    durationSeconds: recording.duration_seconds,
    profile: profileWithOrientationModels(recording.profile),
    loadPositionDistribution: (signal) => fetchPositionDistributionPath("/platform/v1/me/demo-recording/position-distribution", signal),
    loadCapabilities: fetchDemoCapabilities,
    loadOverview: fetchDemoOverview,
    loadWindow: fetchDemoWindow,
  }) : null, [recording, accessIdentity]);
  useEffect(() => { document.title = "Demonstration recording · Rekonas"; }, []);
  if (query.isPending) return <main className="operational-loading"><Spinner /> Loading demonstration…</main>;
  if (!recording || !source) return <main className="operational-main"><Alert>
    <h1>Demonstration recording is unavailable.</h1><p>Access may have been removed.</p>
    <Link to="/recordings">Return to recordings</Link></Alert></main>;
  return <main className="operational-main operational-viewer-main">
    <Link className="operational-back" to="/recordings"><span aria-hidden="true">←</span> All recordings</Link>
    <section className="recording-detail-header"><div><p>Prepared demonstration</p>
      <h1>{recording.label}</h1><span>{recording.recording_ref}</span></div></section>
    <SignalViewer dataSource={source} preferenceIdentity={authCacheScope()}
      provenance={<div className="viewer-provenance-row"><span>{recording.provenance}</span>
        <span>Release <strong>{recording.workspace_ref} · {recording.release_id}</strong></span></div>}
      qualityLabel="Deterministic synthetic fixture"
      summary={<dl className="operational-summary-strip"><div><dt>Duration</dt>
        <dd>{Math.round(recording.duration_seconds / 60)} minutes</dd></div>
        <div><dt>Source</dt><dd>Read-only demo release</dd></div></dl>} />
  </main>;
}
